// extracted by mini-css-extract-plugin
export default {"welcome":"Welcome_welcome__b6Ahj","question":"Welcome_question__xcY1f","link":"Welcome_link__ijyb6","form":"Welcome_form__QU2Zf","category":"Welcome_category__YMoWT"};